<template>
  <div class="login">
    <div class="form">
      <div class="logo">
        <svg width="73" height="21" viewBox="0 0 73 21" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5.304 2.448v17.795H.473V2.448h4.831zM12.46 12.736v7.507H7.663V6.897h4.553v2.537h.14c.29-.846.799-1.51 1.529-1.99.735-.48 1.593-.721 2.572-.721.944 0 1.764.217 2.459.652a4.33 4.33 0 011.625 1.772c.388.753.579 1.614.573 2.58v8.516h-4.796v-7.507c.005-.66-.163-1.179-.504-1.556-.336-.376-.806-.564-1.408-.564-.394 0-.739.087-1.034.26a1.67 1.67 0 00-.669.73c-.156.313-.237.69-.243 1.13zM28.313 20.417c-.95 0-1.825-.249-2.624-.747-.794-.498-1.43-1.254-1.912-2.268-.475-1.014-.712-2.291-.712-3.832 0-1.61.249-2.92.747-3.928.504-1.007 1.153-1.746 1.946-2.215.8-.47 1.64-.704 2.52-.704.66 0 1.24.116 1.738.348.498.225.915.53 1.251.912.336.376.591.79.765 1.242h.07V2.448h4.796v17.795h-4.762v-2.19h-.104a3.751 3.751 0 01-2.05 2.06c-.487.203-1.043.304-1.669.304zm1.773-3.684c.44 0 .816-.128 1.13-.383.318-.26.561-.625.73-1.094.173-.475.26-1.037.26-1.686 0-.66-.087-1.225-.26-1.694-.169-.475-.412-.837-.73-1.086-.314-.255-.69-.383-1.13-.383-.44 0-.817.128-1.13.383-.307.249-.544.61-.712 1.086-.163.469-.244 1.034-.244 1.694 0 .66.081 1.228.244 1.703.168.47.405.831.712 1.086.313.25.69.374 1.13.374zM45.648 20.487c-1.425 0-2.653-.273-3.684-.817a5.724 5.724 0 01-2.372-2.364c-.55-1.03-.826-2.265-.826-3.701 0-1.379.278-2.584.834-3.615a5.962 5.962 0 012.355-2.407c1.014-.573 2.21-.86 3.589-.86 1.008 0 1.92.156 2.737.47a5.734 5.734 0 012.094 1.363c.579.591 1.025 1.31 1.338 2.155.313.846.47 1.799.47 2.859v1.112H40.26v-2.641h7.507a1.84 1.84 0 00-.295-1.008 1.882 1.882 0 00-.756-.687 2.223 2.223 0 00-1.07-.252 2.29 2.29 0 00-1.068.252 2.018 2.018 0 00-.782.678 1.91 1.91 0 00-.304 1.017v2.85c0 .428.09.81.27 1.147.179.336.437.6.773.79.336.192.741.287 1.216.287.33 0 .632-.046.904-.139.278-.092.515-.226.712-.4.197-.18.342-.393.435-.643h4.38c-.151.927-.508 1.733-1.07 2.416-.562.678-1.306 1.205-2.233 1.581-.92.371-1.998.557-3.232.557zM66.57 12.88l-12.233 7.607v-4.742l4.486-3.086-.131.226v-.527l.131.226-4.486-3.086V4.757l12.234 8.128v-.005zM60.454 7.695L72.688.09V4.83l-4.487 3.086.132-.226v.527L68.2 7.99l4.487 3.086v4.741L60.454 7.69v.005z" fill="#fff"/></svg>
      </div>
      <form @submit.prevent="login">
        <label>
          <p>Логин</p>
          <form-input
            v-model="credentials.username"
            autofocus
            autocorrect="off"
            placeholder="Введите логин"
          />
        </label>
        <label>
          <p>Пароль</p>
          <form-input
            v-model="credentials.password"
            type="password"
            autocorrect="off"
            placeholder="Введите пароль"
          />
        </label>
        <button class="button primary" type="submit" :disabled="loading">
          Войти
        </button>
      </form>
    </div>
    <div class="error" v-if="error">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z" fill="#000"/></svg>
      <span>Неверный логин или пароль.</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        username: "",
        password: "",
      },
      loading: false,
      error: false
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.$store
        .dispatch("User/login", this.credentials)
        .then((data) => {
          this.$auth.login(data.token)
          this.$locale.change(data.user.language)
          this.$http.setHeader('Accept-Language', data.user.language)
          this.$router.push({name: 'home'})
        })
        .catch((error) => {
          if (error.status === 401) {
            this.error = true
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>